import { Button, Text } from '@chakra-ui/react';
import { Link } from '~components/ui/Link';
import { Page } from '~components/ui/Page';
import { PageContent } from '~components/ui/PageContent';

export function CustomerNotFoundPage() {
  return (
    <Page title="404" pageName="customers_404" analyticsDisableTracking={true}>
      <PageContent maxWidth="300px" textAlign="center">
        <Text fontWeight="semibold" color="gray.600">
          This customer does not exist, or you don&apos;t have permissions to view it.
        </Text>

        <Text marginTop="8" fontSize="sm">
          Try switching to another customer on the{' '}
          <Button as={Link} variant="link" size="sm" colorScheme="blue" to="../">
            customer overview page.
          </Button>
        </Text>
      </PageContent>
    </Page>
  );
}
